<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication Page" epub:type="dedication" role="doc-dedication">
<p class="linespace" id="ded"> </p>
<p class="ded"><i>This story is dedicated to all the women who want a man workin’ with a little somethin’ somethin’.…</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7bb73160